function DateRange({ onChange }) {
  return (
    <>
      <div className="col-md-5 col-lg-6 d-flex gap-3">
        <div className="mb-3 w-100">
          <label className="form-label fw-bold">Start Date:</label>
          <input
            type="date"
            className="form-control"
            onChange={(e) => onChange(e.target.value, "startDate")}
          />
        </div>
        <div className="d-flex">
          <i className="bi bi-arrow-right align-self-center"></i>
        </div>
        <div className="mb-3 w-100">
          <label className="form-label fw-bold">End Date:</label>
          <input
            type="date"
            className="form-control"
            onChange={(e) => onChange(e.target.value, "endDate")}
          />
        </div>
      </div>
    </>
  );
}

export default DateRange;
